<div class="operation-monitoring-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2>{{ 'Operation Monitoring' | translate }}</h2>
      <p>{{ 'Live assignments and jobs' | translate }}</p>
    </div>
    <div class="header-actions">
      <app-secondary-button
        class="header-actions__refresh"
        title="Refresh"
        icon="pi pi-refresh"
        [disable]="loading"
        (action)="refresh()"
      ></app-secondary-button>
    </div>
  </div>

  <div class="orch-table-panel">
    <app-orchestration-table-heading
      heading="Operations"
      [query]="filters.search ?? ''"
      (queryChange)="onHeaderSearch($event)"
    >
    </app-orchestration-table-heading>
    <div class="orch-filter-toolbar">
      <div class="orch-filter-toolbar__group">
        <select [(ngModel)]="filters.state" [attr.aria-label]="'Status' | translate">
          <option [ngValue]="undefined">{{ 'Status' | translate }}</option>
          @for (state of states; track state) {
            <option [ngValue]="state">{{ state | translate }}</option>
          }
        </select>
        <select [(ngModel)]="filters.kind" [attr.aria-label]="'Operation kind' | translate">
          <option [ngValue]="undefined">{{ 'Operation kind' | translate }}</option>
          @for (kind of kinds; track kind) {
            <option [ngValue]="kind">{{ kind | translate }}</option>
          }
        </select>
      </div>
      <div class="orch-filter-toolbar__group">
        <input
          type="text"
          [(ngModel)]="filters.causationId"
          [attr.aria-label]="'Parent assignment ID' | translate"
          [placeholder]="'Parent assignment ID' | translate"
        />
      </div>
      <div class="orch-filter-toolbar__group">
        <select [(ngModel)]="filters.initiatorKind" [attr.aria-label]="'Initiator' | translate">
          <option [ngValue]="undefined">{{ 'Initiator' | translate }}</option>
          @for (initiatorKind of initiatorKinds; track initiatorKind) {
            <option [ngValue]="initiatorKind">{{ initiatorKind | translate }}</option>
          }
        </select>
        <select [(ngModel)]="filters.channel" [attr.aria-label]="'Channel' | translate">
          <option [ngValue]="undefined">{{ 'Channel' | translate }}</option>
          @for (channel of channels; track channel) {
            <option [ngValue]="channel">{{ channel | translate }}</option>
          }
        </select>
      </div>
      <div class="orch-filter-toolbar__group">
        <input
          type="datetime-local"
          [(ngModel)]="filters.createdFrom"
          [attr.aria-label]="'Created from' | translate"
          [title]="'Created from' | translate"
        />
        <input
          type="datetime-local"
          [(ngModel)]="filters.createdTo"
          [attr.aria-label]="'Created to' | translate"
          [title]="'Created to' | translate"
        />
      </div>
      <div class="orch-filter-toolbar__group">
        <button pButton type="button" [label]="'Apply' | translate" (click)="filters.page = 1; loadOperations()"></button>
        <button
          pButton
          type="button"
          severity="secondary"
          [label]="'Reset' | translate"
          (click)="resetFilters()"></button>
      </div>
    </div>
    @if (loading && operations.length === 0) {
      <app-loading [loading]="true"></app-loading>
    } @else if (errorMessage && !loading) {
      <div class="error-message">{{ errorMessage | translate }}</div>
    } @else {
      <div class="orch-table-grid" [class.orch-table-grid--busy]="loading" [attr.aria-busy]="loading">
      @if (loading) {
        <app-loading [loading]="true"></app-loading>
      }
      <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>{{ 'Created At' | translate }}</th>
            <th>{{ 'Operation kind' | translate }}</th>
            <th>{{ 'Assignment name' | translate }}</th>
            <th>{{ 'Operation type' | translate }}</th>
            <th>{{ 'Assignment' | translate }}</th>
            <th>{{ 'Initiator' | translate }}</th>
            <th>{{ 'Channel' | translate }}</th>
            <th>{{ 'Status' | translate }}</th>
            <th>{{ 'Executed on' | translate }}</th>
            <th>{{ 'Progress' | translate }}</th>
            <th>{{ 'Duration' | translate }}</th>
            <th>{{ 'Correlation ID' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (operation of operations; track operation.id ?? $index) {
            <tr (click)="openDetails(operation)">
              <td>{{ operation.createdAt | dateFormatLang:translate.currentLang:'seconds' }}</td>
              <td>{{ (operation.kind ?? '—') | translate }}</td>
              <td>{{ operation.name || '—' }}</td>
              <td>
                <app-copyable-identifier [value]="operation.operationType || ''"></app-copyable-identifier>
              </td>
              <td (click)="$event.stopPropagation()">
                @if (operation.assignmentUrl) {
                  <a class="id-link assignment-link" [routerLink]="operation.assignmentUrl">{{ operation.id }}</a>
                } @else {
                  —
                }
              </td>
              <td>{{ (operation.initiatorKind ?? '—') | translate }}</td>
              <td>{{ (operation.channel ?? '—') | translate }}</td>
              <td><p-tag [value]="(operation.state ?? '—') | translate" [severity]="getStateSeverity(operation.state)"></p-tag></td>
              <td>
                <app-assignment-host-label
                  [serviceName]="operation.workerServiceName"
                  [hostName]="operation.workerHostName"
                  [workerVersion]="operation.workerVersion"
                  [workerId]="operation.workerId"
                  [fallback]="operation.hostLabel"
                ></app-assignment-host-label>
              </td>
              <td class="progress-cell">
                <p-progressbar [value]="operation.progressPercentage ?? 0" [showValue]="true"></p-progressbar>
              </td>
              <td>{{ formatDuration(operation.durationSeconds) }}</td>
              <td>
                <app-copyable-identifier [value]="operation.correlationId || ''"></app-copyable-identifier>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="11" class="empty-state">{{ 'No operations found' | translate }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
      </div>

    <app-custom-paginator
      [first]="first"
      [pageSize]="filters.pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
    }
  </div>
</div>

